import { DragTapSurface } from "../drag-tap-surface/DragTapSurface";
import { Container, HandleBar, Props } from "./Handle.Parts";

export const Handle = ({ backgroundColor }: Props) => (
  <DragTapSurface>
    <Container $backgroundColor={backgroundColor}>
      <HandleBar />
    </Container>
  </DragTapSurface>
);
